import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import VerificationPortal from './pages/verification-portal';
import PatientRecords from './pages/patient-records';
import PrescriptionManagement from './pages/prescription-management';
import SafetyIncidentReporting from './pages/safety-incident-reporting';
import CredentialWallet from './pages/credential-wallet';
import TrainingCompliance from './pages/training-compliance';
import ProviderDashboard from './pages/provider-dashboard';
import VideoConsultation from './pages/video-consultation';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<CredentialWallet />} />
        <Route path="/verification-portal" element={<VerificationPortal />} />
        <Route path="/patient-records" element={<PatientRecords />} />
        <Route path="/prescription-management" element={<PrescriptionManagement />} />
        <Route path="/safety-incident-reporting" element={<SafetyIncidentReporting />} />
        <Route path="/credential-wallet" element={<CredentialWallet />} />
        <Route path="/training-compliance" element={<TrainingCompliance />} />
        <Route path="/provider-dashboard" element={<ProviderDashboard />} />
        <Route path="/video-consultation" element={<VideoConsultation />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
